import { createApp } from 'vue'
import App from './App.vue'
import './styles.css'

const el = document.getElementById('ebus-countries-app')
if (el) createApp(App).mount(el)
